import { UserAuthCompany } from 'types/api/user/session'

export function getCompanyName(company: UserAuthCompany): string {
  return company?.alias ?? company?.name
}
